const Panchakarma = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <div className="mx-auto h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <p className="mt-6 font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Reinigung und Regeneration
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Die reinigende Reise zur Erneuerung von Körper und Geist: Panchakarma
                    </h2>
                    <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            Im Ayurveda gilt Panchakarma als einer der tiefgreifendsten und wirksamsten Ansätze, um den Körper von innen zu reinigen und die ursprüngliche Vitalität wieder zu erwecken. Diese traditionelle Entgiftung behandelt nicht nur die unmittelbaren Symptome, sondern greift an der Ursache an und bringt die drei Lebensenergien Vata, Pitta und Kapha wieder in ihr natürliches Gleichgewicht.
                        </p>
                        <p>
                            Auf Sanskrit bedeutet Panchakarma „die fünf Maßnahmen“, und damit sind die fünf Behandlungen im Rahmen der ayurvedischen Entgiftung gemeint. Die eigentliche Therapie wird individuell von einem Arzt nach Konstitution, Tageszustand und körperlichem Befinden angepasst. So kann der verspürte Widerstand von Körper und Geist sanft aufgelöst und durch eine klare, ruhige Harmonie ersetzt werden.
                        </p>
                    </div>
                    <div className="mx-auto mt-8 h-px w-32 bg-amber-200" />
                </div>
            </div>
        </section>;
};
export default Panchakarma;
